module.exports = __webpack_public_path__ + "img/20190907135717569.ce2a2925.jpg";